import { getQRCodeLoginUuid } from "@/apis/common";
import { checkQRCodeLoginUuid } from "@/apis/user";
import { DialogLocal } from "@/components/Dialog";
import { USER_TOKEN } from "@/constants";
import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { getLoginUrlScheme } from "@/logic/app";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { selectorLocalStorage, useLocalStorage } from "@/stores/localstorage";
import { setBusinessAxiosToken } from "@/utils/request";
import tools from "@/utils/tool";
import { useLockFn, useMount, useUnmount } from "ahooks";
import { Toast } from "antd-mobile";
import { ToastHandler } from "antd-mobile/es/components/toast";
import QRCode from "qrcode";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Sentry from '@sentry/react';
/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {}

const pagestate = {};

type ActionType = "update-hello";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-hello":
      return Object.assign({}, state, {});

    default:
      return state;
  }
};

let timer: NodeJS.Timeout;
let toastHandler: ToastHandler | undefined;
export const useSetup = () => {
  const navigate = useNavigate();
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {},
  );
  const [QRcode, setQRCode] = useState("");
  const [_uuid, setUUID] = useState("");
  const { login } = useUserAuthContext();
  const [, setToken] = useLocalStorage(USER_TOKEN, "")(selectorLocalStorage);

  const uuid = useLockFn(async () => {
    const response = await getQRCodeLoginUuid({});
    if (response.ok) {
      setUUID(response.data!.uuid);
      QRCode.toDataURL(getLoginUrlScheme(response.data!.uuid))
        .then((url) => {
          setQRCode(url);
        })
        .catch((e) => {
          // TODO: 上报错误
          
          Sentry.captureException(new Error('二维码生成失败'));
          DialogLocal({
            title: "提示",
            content: "二维码生成失败，请刷新二维码。",
            confirmText: "刷新二维码",
            confirmTextColor: "#6f59fe",
            async onConfirm() {
              uuid();
              return true;
            },
            async onCancel() {
              navigate(-1);
              return true;
            },
          });
        });
    } else {
      DialogLocal({
        title: "提示",
        content: "二维码请求失败，请刷新二维码。",
        confirmText: "刷新二维码",
        confirmTextColor: "#6f59fe",
        async onConfirm() {
          uuid();
          uuidStatus();
          return true;
        },
        async onCancel() {
          navigate(-1);
          return true;
        },
      });
    }
  });

  const uuidStatus = useLockFn(async () => {
    const response = await checkQRCodeLoginUuid({ uuid: _uuid });

    if (response.ok) {
      switch (response.data!.state) {
        case "confirm":
          clearTimeout(timer);
          // 储存到 localStorage
          setToken(response.data?.token as string);
          // 设置请求头token
          setBusinessAxiosToken(response.data?.token as string);
          login(response.data!.userInfo);
          break;
        case "canceled":
          clearTimeout(timer);
          DialogLocal({
            title: "提示",
            content: "新设备登录已取消",
            confirmTextColor: "#6f59fe",
            async onConfirm() {
              navigate(-1);
              return true;
            },
          });
          break;
        case "invalid":
          clearTimeout(timer);
          DialogLocal({
            title: "提示",
            content: "验证已失效，请重新扫码。",
            confirmText: "重新扫码",
            confirmTextColor: "#6f59fe",
            async onConfirm() {
              uuid();
              return true;
            },
            async onCancel() {
              navigate(-1);
              return true;
            },
          });
          break;
        case "scanned":
          if (!tools.isUndefined(toastHandler)) {
            toastHandler = Toast.show({
              icon: "loading",
              content: "等待确认",
              duration: 0,
            });
          }
          timer = setTimeout(() => uuidStatus(), 5 * 1000);
          break;
        default:
          toastHandler && toastHandler.close();
          toastHandler = undefined;
          break;
      }
    } else {
      timer = setTimeout(() => uuidStatus(), 5 * 1000);
    }
  });

  useMount(() => {
    uuid();
  });
  useUnmount(() => {
    clearTimeout(timer);
  });

  return { state, dispatch, navigate, QRcode };
};
